import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { INewbuilding } from 'shared/types/newbuilding/newbuilding';
import { addFavorite, removeFavorite } from '../../thunks';

const initialState = {} as INewbuilding;

/* istanbul ignore next */
const newbuildingSlice = createSlice({
  initialState,
  name: 'newbuilding',
  reducers: {
    setFavorite: (state, action: PayloadAction<boolean>) => {
      state.isFavorite = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(addFavorite.fulfilled, (state, action) => {
      state.isFavorite = action.payload.isFavorite;
    });
    builder.addCase(removeFavorite.fulfilled, (state, action) => {
      state.isFavorite = action.payload.isFavorite;
    });
  },
});

export const {
  reducer: newbuildingReducer,
  actions: { setFavorite },
} = newbuildingSlice;
